import { useContext, useMemo, useRef, useState } from "react";

import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Overlay from "../Componentes/Overlay";
import SideMenu from "../Componentes/SideMenu";
import SideMenuBtn from "../Componentes/SideMenuBtn";
import TestesAlcoolDrogasContent from "../Modulos/AtendimentoAmb/TestesAlcoolDrogas/Content";
import ModalNovoTeste from "../Modulos/AtendimentoAmb/TestesAlcoolDrogas/ModalNovoTeste";
import { AuthContext } from "../Auth/AuthProvider";
import { VerifyPermission } from "../Funcoes/VerifyPermission";
import { useModal } from "../contexts/ModalContext";
import { useToast } from "../contexts/ToastContext";
import useApi from "../hooks/useApi";

const PERMISSAO_BASE = { modulo: "ssma", submodulo: "atendimento-amb" };

const AtendimentoAmbTestesAlcoolDrogas = () => {
    const { openModal, closeModal, isModalOpen } = useModal();
    const { user } = useContext(AuthContext);
    const { notifyError } = useToast();
    const api = useApi();
    const contentRef = useRef(null);
    const [listRefreshKey, setListRefreshKey] = useState(0);
    const [loadingRelatorio, setLoadingRelatorio] = useState(false);

    const podeLancarEditar = useMemo(
        () => VerifyPermission(user, { ...PERMISSAO_BASE, funcao: "testes-alcool-drogas-lancar-editar" }),
        [user]
    );

    const openSidebar = () => openModal("testesAlcoolDrogasSidebar");

    const openNovoTeste = () => {
        if (!podeLancarEditar) return;
        closeModal();
        openModal("testeNovo");
    };

    const gerarRelatorio = async () => {
        if (loadingRelatorio) return;

        const filtrados = contentRef.current?.getFilteredTestes?.() ?? [];

        if (filtrados.length === 0) {
            notifyError("Nenhum teste encontrado com os filtros atuais.");
            return;
        }

        setLoadingRelatorio(true);

        try {
            const response = await api.post(
                "/Painel/API/AtendimentoAmb/TestesAlcoolDrogas/GenerateRelatorio/index.php",
                filtrados,
                { responseType: "blob" }
            );

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            const stamp = new Date().toISOString().slice(0, 19).replace(/[-:T]/g, "").slice(0, 14);
            link.href = url;
            link.setAttribute("download", `testes_alcool_drogas_${stamp}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error(err);
            let msg = "Erro ao gerar relatório.";
            if (err?.response?.data instanceof Blob) {
                try {
                    const parsed = JSON.parse(await err.response.data.text());
                    if (parsed?.message) msg = parsed.message;
                } catch {
                    /* mantém mensagem padrão */
                }
            } else if (err?.response?.data?.message) {
                msg = err.response.data.message;
            }
            notifyError(msg);
        } finally {
            setLoadingRelatorio(false);
        }
    };

    return (
        <>
            <NavBar
                title="ATENDIMENTO AMBULATORIAL — TESTES ÁLCOOL E DROGAS"
                goBackOnePage
                setSideBar={openSidebar}
            />
            <GenericBody>
                <TestesAlcoolDrogasContent ref={contentRef} refreshKey={listRefreshKey} />
            </GenericBody>

            {isModalOpen("testesAlcoolDrogasSidebar") && (
                <Overlay state changeContent={closeModal}>
                    <SideMenu>
                        {podeLancarEditar && (
                            <SideMenuBtn
                                button="NOVO TESTE"
                                clickFunc={openNovoTeste}
                            />
                        )}
                        <SideMenuBtn
                            button="GERAR RELATÓRIO"
                            clickFunc={gerarRelatorio}
                            isLoading={loadingRelatorio}
                        />
                    </SideMenu>
                </Overlay>
            )}

            {podeLancarEditar && isModalOpen("testeNovo") && (
                <ModalNovoTeste
                    fechar={closeModal}
                    onSaved={() => setListRefreshKey((k) => k + 1)}
                />
            )}
        </>
    );
};

export default AtendimentoAmbTestesAlcoolDrogas;
